// No 0/O/1/I/L to keep codes easy to read out loud.
const ALPHABET = "ABCDEFGHJKMNPQRSTUVWXYZ23456789";

export function randomCode(length) {
  const bytes = new Uint32Array(length);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => ALPHABET[b % ALPHABET.length]).join("");
}

export const ROOM_CODE_LENGTH = 5;
export const FRIEND_CODE_LENGTH = 6;

export const normalizeCode = (code) =>
  (code || "").toUpperCase().replace(/[^A-Z0-9]/g, "");

export const roomLink = (code) => `${window.location.origin}/r/${code}`;

export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

export const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];
